<template>
    <div class="row">
    	<div class="col-xs-12">
    		<v-presentationtable :pid="pid"></v-presentationtable>
    	</div>
    </div>
</template>

<script>
// Base

// Componenets

// funktion

// helper

export default {
	name: 'p-presentations',
	props: ['pid']
}
</script>



// WEBPACK FOOTER //
// src/pages/p-presentations.vue